<template>
  <div class="auth-wrapper">
    <section class="section">
      <h1 class="is-size-4 has-text-grey">
        {{ $t('Секунду... Авторизируемся') }}
      </h1>
    </section>
  </div>
</template>

<script>
export default {
  created () {
    window.location.replace(`${__config.services.id}/login`)
  }
}
</script>
